/* eslint-disable react/no-this-in-sfc */
/* eslint-disable camelcase */
const React = require('react');

const { useState, useEffect, useCallback } = React;

const { bool, string, shape, func, number } = require('prop-types');

const Dropdown = require('@andes/dropdown');
const Button = require('@andes/button');

const { track } = require('../helpers');

const { DropdownNative, DropdownNativeItem } = Dropdown;
const { STATE_ID_KEY } = require('../constants/location-keys');


const namespace = 'state-city';

const StateCity = ({
  states,
  cities,
  main_action,
  errors,
  autoFocus,
  stateChanged,
  cityChanged,
  lowEnd,
  deviceType,
  translations,
  isLoggedIn,
  selectedAddress,
  stateCitySubmitted,
  webView,
  setShowSpinner,
  actionsUrls,
  analytics,
  melidata,
}) => {
  const checkIfCitiesEmpty = () => cities.values === null || (cities.values.length === 1 && cities.values[0].id === '0');
  const [citiesValues, setCitiesValues] = useState(cities.values);
  const [isCitiesEmpty, setIsCitiesEmpty] = useState(checkIfCitiesEmpty);
  const [cityError, setCityError] = useState(errors && errors.city);
  const [selectedCity, setSelectedCity] = useState(cities.selected);
  const [selectedState, setSelectedState] = useState(states.selected);

  useEffect(() => {
    if (selectedAddress) {
      setSelectedState('0');
      setSelectedCity('0');
      setCitiesValues([{ name: translations.selectOption, id: '0' }]);
      setIsCitiesEmpty(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAddress]);

  const handleCityChange = (event, value) => {
    if (cityChanged) {
      cityChanged(value);
    }
    setSelectedCity(value);
  };

  const handleStateChange = (event, value) => {
    if (stateChanged) {
      stateChanged(value);
    }
    setSelectedState(value);
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', function onLoadStateChange() {
      if (this.status === 200) {
        const values = JSON.parse(this.responseText);
        setIsCitiesEmpty(!values.length);
        values.unshift({ name: translations.selectOption, id: '0' });
        setCitiesValues(values);
        handleCityChange(null, values[0].id);
        setCityError(null);
      } else {
        setCityError(this.responseText.includes(STATE_ID_KEY) ? translations.errorMsg : this.responseText);
      }
    });
    xhr.open('GET', `api/location/cities?state_id=${encodeURIComponent(value)}`);
    xhr.send();
  };

  const handleSubmitButtonClick = () => {
    window.parent.postMessage({ type: 'nav:cp:redirect' }, '*');

    track(
      'hub',
      'add_zipcode',
      {
        zipcode: `${selectedState}_${selectedCity}`,
        has_errors: false,
        ...melidata?.event_data,
      },
      { ...analytics?.dimesions },
    );

    if (stateCitySubmitted) {
      stateCitySubmitted();
    }
    if (!webView) {
      setShowSpinner(true);
    }
  };

  const stateLabel = states.label ? states.label.toLowerCase() : '';
  const navigationAddressHubClick = useCallback(
    () => (e) => {
      if (window.MobileWebKit.engine === window.MobileWebKit.Engines.V200) {
        e.preventDefault();
        window.MobileWebKit.navigation.push(
          `meli://webview/?webkit-engine=2&url=${encodeURIComponent(
            `${actionsUrls.navigateAddress}?state_id=${states.selected}`,
          )}`,
          { screens_group: 'addressHubGroup' },
        );
      }
    },
    [actionsUrls?.navigateAddress, states.selected],
  );

  return (
    <div className={namespace}>
      <div className={`${namespace}__dropdown`}>
        <DropdownNative
          type="form"
          name="state_id"
          data-testid="stateDropdown"
          width={100}
          label={states.label}
          value={selectedState}
          modifier={(errors !== null && errors.state !== null) ? 'error' : undefined}
          helper={(errors && errors.state) || ' '}
          autoFocus={(!!errors && !!errors.state) || autoFocus || (!!states.selected && isCitiesEmpty)}
          className={!isCitiesEmpty && lowEnd ? 'andes-form-control--disabled' : ''}
          id="stateDropdown"
          onChange={handleStateChange}
        >
          {states.values && states.values.map(({ id, name }) => <DropdownNativeItem key={id} value={id} title={name} />)}
        </DropdownNative>
      </div>
      {!isCitiesEmpty && lowEnd && (
        <a
          className={`${namespace}__change-address`}
          {...(webView && {
            onClick: navigationAddressHubClick,
          })}
          href={
            webView
              ? `meli://webview/?url=${encodeURIComponent(`/navigation/addresses-hub?state_id=${states.selected}`)}`
              : `/navigation/addresses-hub?state_id=${encodeURIComponent(states.selected)}`
          }
          title={`${translations.change} ${stateLabel}`}
        >
          {translations.change} {stateLabel}
        </a>
      )}
      {(!isCitiesEmpty || !lowEnd) && (
        <div className={`${namespace}__dropdown`}>
          <DropdownNative
            type="form"
            name="city_id"
            data-testid="citiesDropdown"
            width={100}
            label={cities.label}
            value={selectedCity}
            disabled={isCitiesEmpty}
            modifier={cityError ? 'error' : undefined}
            helper={cityError || ' '}
            autoFocus={!isCitiesEmpty || cityError}
            id="citiesDropdown"
            onChange={handleCityChange}
          >
            {citiesValues && citiesValues.map(({ id, name }) => <DropdownNativeItem key={id} value={id} title={name} />)}
          </DropdownNative>
        </div>
      )}
      <Button
        type="submit"
        className={`${namespace}__use-button`}
        hierarchy={deviceType === 'mobile' && isLoggedIn ? 'loud' : 'quiet'}
        size="large"
        disabled={(!lowEnd && isCitiesEmpty) || selectedCity === '0'}
        onClick={handleSubmitButtonClick}
        data-testid="submit-button"
      >
        {isCitiesEmpty && lowEnd ? translations.next : main_action.label}
      </Button>
    </div>
  );
};

StateCity.propTypes = {
  main_action: shape({}).isRequired,
  states: shape({}).isRequired,
  cities: shape({}).isRequired,
  errors: shape({
    state: string,
    city: string,
  }),
  autoFocus: bool,
  stateChanged: func,
  cityChanged: func,
  lowEnd: bool.isRequired,
  deviceType: string.isRequired,
  translations: shape({ selectOption: string }).isRequired,
  isLoggedIn: bool.isRequired,
  selectedAddress: number,
  stateCitySubmitted: func,
  webView: bool.isRequired,
  setShowSpinner: func,
  actionsUrls: shape({ navigationAddress: string }),
  analytics: shape({
    dimesions: shape({}),
  }),
  melidata: shape({
    event_data: shape({}),
  }),
};

StateCity.defaultProps = {
  title: '',
  errors: null,
  autoFocus: false,
  stateChanged: null,
  cityChanged: null,
  selectedAddress: null,
  stateCitySubmitted: null,
  webView: false,
};

module.exports = StateCity;
